import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Company } from '@app/models/company/company.model';
import { SelfServeOnboarding } from '@app/models/self-serve/self-serve-onboarding.model';
import { OnboardingStatusService } from '@app/modules/self-serve/services/onboarding-status.service';
import { AuthService, NotifyService } from '@app/services';

@Component({
    templateUrl: './tell-us.template.html',
    styleUrls: ['../../../self-serve.style.scss'],
})
export class TellUsView implements OnInit {
    @ViewChild('form', { static: true }) form!: NgForm;
    selfServeOnboarding: SelfServeOnboarding = new SelfServeOnboarding();
    isLoading = true;
    isSaving = false;

    readonly payrollProviders = [
        'ADP',
        'Ceridian',
        'Payweb',
        'Payworks',
        'Quickbooks',
        'Rise',
        'Sage',
        'Wagepoint',
        'Wave',
        'Other',
    ];

    private nextPage = 'timeline';

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authService: AuthService,
        private notifyService: NotifyService,
        private onboardingStatusService: OnboardingStatusService
    ) {}

    async ngOnInit(): Promise<void> {
        try {
            const company = await Company.with('selfServeOnboarding').find(this.authService.company.id);
            this.selfServeOnboarding = company.selfServeOnboarding;

            this.isLoading = false;
        } catch (error) {
            this.notifyService.error(error);
        }
    }

    /**
     * onChangeData handles changes to the data that require further changes
     * to other data!
     */
    onChangeData(): void {
        if (!this.selfServeOnboarding.hasRunPayrollThisYear) {
            this.selfServeOnboarding.hasCurrentPayrollProvider = false;
        }

        if (!this.selfServeOnboarding.hasCurrentPayrollProvider) {
            this.selfServeOnboarding.currentPayrollProvider = null;
        }
    }

    async onSubmit(): Promise<void> {
        if (!this.form.valid || this.isSaving) {
            return;
        }

        try {
            this.isSaving = true;
            if (!this.selfServeOnboarding.hasCurrentPayrollProvider) {
                this.selfServeOnboarding.currentPayrollProvider = null;
            }
            await this.selfServeOnboarding.save();
            this.onboardingStatusService.refresh();
            this.next();
        } catch (error) {
            this.notifyService.error(error);
            this.isSaving = false;
        }
    }

    next(): void {
        this.router.navigate(['..', this.nextPage], { relativeTo: this.route });
    }
}
